module.exports = __webpack_public_path__ + "static/Zasób 5@2x-3602d809365cb8ed022015f44116b39f.png";